import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servConsultaAcesso from "../../services/login/servConsultaAcesso"

const TipoGeracaoSearchField = ({ field, id, setOpenError, setErrorMessage, disabled=false, onKeyDown, className="" }) => {

    const loadTipoGeracao = async (inputValue) => {
        try {
            
            const response = await servConsultaAcesso.RecuperarTipoGeracao(inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    }

    const mapResponseToValuesAndLabels = (data) => {
        return {
            value: data.Id,
            label: data.Descricao
        }
    }

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Selecione um tipo de geração"
            loadOptions={loadTipoGeracao}
            defaultOptions
            isDisabled={disabled}
            styles={SearchFieldStyles}
            {...field}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { TipoGeracaoSearchField }